import React, { useState } from "react";
import { LifeBuoy, X, MessageCircle, Mail, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { KD9_CONTACT } from "@/lib/contact";

const SupportButton = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="floating-support-btn"
        aria-label="Soporte KD9"
        className="fixed bottom-24 right-6 z-40 flex items-center gap-3 px-5 py-3 rounded-full font-mont text-[11px] font-semibold tracking-[0.16em] uppercase transition-all hover:-translate-y-0.5"
        style={{
          background: "linear-gradient(180deg,#4BC58F,#1FA774)",
          color: "#0a0a0a",
          boxShadow:
            "0 12px 32px -8px rgba(31,167,116,0.5), 0 0 0 1px rgba(31,167,116,0.4)",
        }}
      >
        <LifeBuoy size={16} />
        <span className="hidden sm:inline">Soporte KD9</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-end justify-end p-6">
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          />
          <div
            className="relative w-full sm:w-96 kd9-card p-6 kd9-fade-up"
            data-testid="support-panel"
          >
            <button
              onClick={() => setOpen(false)}
              aria-label="Cerrar"
              className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center border"
              style={{ borderColor: "var(--kd9-border)" }}
            >
              <X size={14} />
            </button>
            <div className="flex items-center gap-3 mb-5">
              <div
                className="w-11 h-11 rounded-full flex items-center justify-center"
                style={{
                  background: "rgba(31,167,116,0.16)",
                  border: "1px solid rgba(31,167,116,0.45)",
                }}
              >
                <LifeBuoy size={18} style={{ color: "#1FA774" }} />
              </div>
              <div>
                <div className="font-cinzel kd9-gold-text text-lg tracking-wider">
                  SOPORTE KD9
                </div>
                <div
                  className="font-mont text-[11px]"
                  style={{ color: "var(--kd9-text-soft)" }}
                >
                  Estamos aquí para acompañarte
                </div>
              </div>
            </div>

            <p
              className="font-cormorant text-base mb-5"
              style={{ color: "var(--kd9-text-soft)" }}
            >
              Si necesitas ayuda con tu cuenta, navegación, pagos en verificación o
              algo técnico — escríbenos. Tu caso será revisado por el equipo KD9.
            </p>

            <div className="space-y-2">
              <a
                href={KD9_CONTACT.supportWhatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 rounded-lg border transition-all hover:-translate-y-0.5"
                style={{ borderColor: "var(--kd9-border)" }}
                data-testid="support-whatsapp"
              >
                <MessageCircle size={16} style={{ color: "#1FA774" }} />
                <div className="flex-1">
                  <div className="font-mont text-sm font-semibold">WhatsApp</div>
                  <div
                    className="font-mont text-[11px]"
                    style={{ color: "var(--kd9-text-soft)" }}
                  >
                    Respuesta en menos de 24h
                  </div>
                </div>
                <ExternalLink size={12} />
              </a>

              <a
                href={KD9_CONTACT.supportEmailUrl}
                className="flex items-center gap-3 px-4 py-3 rounded-lg border transition-all hover:-translate-y-0.5"
                style={{ borderColor: "var(--kd9-border)" }}
                data-testid="support-email"
              >
                <Mail size={16} style={{ color: "var(--kd9-accent)" }} />
                <div className="flex-1">
                  <div className="font-mont text-sm font-semibold">Correo</div>
                  <div
                    className="font-mont text-[11px]"
                    style={{ color: "var(--kd9-text-soft)" }}
                  >
                    {KD9_CONTACT.email}
                  </div>
                </div>
              </a>

              <Link
                to={user ? "/app/soporte" : "/login"}
                state={user ? undefined : { from: "/app/soporte" }}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-lg border transition-all hover:-translate-y-0.5"
                style={{ borderColor: "var(--kd9-border)" }}
                data-testid="support-ticket"
              >
                <LifeBuoy size={16} style={{ color: "var(--kd9-gold)" }} />
                <div className="flex-1">
                  <div className="font-mont text-sm font-semibold">
                    Abrir ticket de soporte
                  </div>
                  <div
                    className="font-mont text-[11px]"
                    style={{ color: "var(--kd9-text-soft)" }}
                  >
                    Para casos que requieran seguimiento
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportButton;
